import React from 'react';
import audio from 'shared/utils/audio';
import { Container, TabContainer, TabImage, TabsWrapper, PurpleUnderline } from './styledComponents';
import { useTheme } from 'styled-components';
import { REWARD_CENTER_TABS } from 'shared/screens/RewardCenter/constants';

const ControlHeader = props => {
  const { activeTab, setActiveTab, setPrevTab, rewardCenterAssets, profileTabs } = props;
  const { RewardCenter } = useTheme();

  const renderTab = tab => {
    if (!tab.show) return null;

    const isSelected =
      activeTab === tab.key ||
      (activeTab === REWARD_CENTER_TABS.HISTORY_DETAIL && tab.key === REWARD_CENTER_TABS.HISTORY);

    return (
      <TabContainer
        key={tab.key}
        onClick={() => {
          audio.onClick();
          setPrevTab(activeTab);
          setActiveTab(tab.key);
        }}
        className={`RewardCenterTab${isSelected ? ' Active' : ''}`}
        data-tab-name={tab.key}
      >
        <TabImage
          theme={isSelected ? RewardCenter.ActiveTabImage : RewardCenter.TabImage}
          src={isSelected ? tab.selectedImage : tab.defaultImage}
          alt=""
        />
      </TabContainer>
    );
  };

  return (
    <Container>
      <div className="RewardCenterHeader">
        <TabsWrapper>{profileTabs.map(renderTab)}</TabsWrapper>
      </div>
      <PurpleUnderline src={rewardCenterAssets.REWARD_CENTER_MENU_UNDERLINE} alt="" />
    </Container>
  );
};

export default ControlHeader;

